<template>
  <Navigation :title="this.package.name" />
  <div class="pb-5 bg-finger">
    <div class="container" style="height: 150px"></div>
  </div>

  <div class="container-fluid" style="margin-top: -5em">
    <div class="card package-card">
      <div class="card-body">
        <p class="text-primary fw-bold package-name">{{ this.package.name }}</p>
        <span class="fw-bold d-block package-target mb-3">
          {{ this.package.grouping }}
          <br />
          <span class="text-muted package-consultation">
            {{ this.package.is_consultation == '1' ? $t('freeConsult') : $t('noConsult') }}
          </span>
        </span>
        <span class="fw-bold fs-4">{{ 'Rp.' + Intl.NumberFormat('id').format(this.package.price) }}</span>
      </div>
    </div>
  </div>

  <div class="container-fluid mb-5 pb-3 padding-tab-content">
    <p class="text-center fw-bold fs-5">{{ $t('features') }}</p>
    <ul class="mt-4 feature">
      <li v-for="fitur in this.package.content" v-bind:key="fitur">
        {{ fitur }}
      </li>
    </ul>
    <div class="mt-4 px-3">
      <div class="form-check mb-2" @click="toggleCounselor">
        <input
          class="form-check-input"
          type="checkbox"
          value=""
          id="check_counselor"
          v-bind:checked="this.package.is_consultation === '1'" />
        <label class="form-check-label consult-check-label" for="check_counselor">
          {{ $t('includeConsultation') }}
        </label>
      </div>
      <button
        class="btn btn-primary rounded-pill"
        @click="toggleCounselor"
        v-if="this.package.is_consultation === '1' && !selected_counselor.name">
        {{ $t('selectCounselor') }}
      </button>
      <div class="card" v-if="selected_counselor.name">
        <div class="card-body">
          <p style="font-size: 10pt">{{ $t('selectedCounselor') }} :</p>
          <div class="d-flex align-items-center gap-4 mb-2">
            <img
              :src="`/img/counselor/team-member-${selected_counselor.id}.jpg`"
              class="rounded-circle"
              width="140"
              alt="" />
            <div>
              <p>
                {{ $t('consultationType') }} <br />
                <b>{{ consultation_type.toUpperCase() }}</b>
              </p>
              <p>
                {{ $t('counselorName') }} <br />
                <b>{{ selected_counselor.name }}</b>
              </p>
            </div>
          </div>
          <div v-if="selected_counselor.name">
            <div class="d-flex mt-3 gap-2   ">
              <div class="col-4">
                <button type="button" class="btn btn-outline-primary rounded-pill w-100" @click="toggleCounselor">
                    {{ $t('edit') }}
                </button>
              </div>
              <div class="col">
                <button type="button" class="btn btn-danger rounded-pill w-100" @click="cancel_counselor">
                  {{ $t('cancel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="card mb-5">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <p class="p-0 m-0">{{ $t('testPackage') }}</p>
            <p class="p-0 m-0">{{ Intl.NumberFormat('id').format(this.package.price) }}</p>
          </div>
          <div class="d-flex justify-content-between" v-if="selected_counselor.name">
            <p class="p-0 m-0">{{ $t('includeConsultation') }}</p>
            <p class="p-0 m-0">{{ this.package.is_consultation == '0' ? Intl.NumberFormat('id').format(selected_counselor.price) : "0" }}</p>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <p class="p-0 m-0 fw-bold">{{ $t('total') }}</p>
            <p class="p-0 m-0 fw-bold">{{ Intl.NumberFormat('id').format(totalPrice) }}</p>
          </div>
        </div>
      </div>
      <button class="btn btn-primary rounded-pill fw-bold w-100" @click="triggerPesan">
        {{ $t('continue') }} <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>
  </div>

  <BottomNav />

  <!-- Button trigger modal -->
  <button
    type="button"
    id="btn-open-modal"
    class="btn btn-primary d-none"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal">
    Launch demo modal
  </button>

  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ $t('selectCounselor') }}</h5>
        </div>
        <div class="modal-body">
          <div class="alert alert-info">
            <i class="bi bi-info-circle me-2"></i> Please contact call center for availability
          </div>
          <div class="row">
            <span class="d-block fw-bold mb-2">{{ $t('consultationType') }}</span>
            <div class="btn-group mb-3" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                class="btn-check"
                @click="this.consultation_type = 'online'"
                name="btnradio"
                id="btnradio1"
                autocomplete="off" />
              <label class="btn btn-outline-primary" for="btnradio1">{{ $t('online') }}</label>
              <input
                type="radio"
                class="btn-check"
                @click="this.consultation_type = 'offline'"
                name="btnradio"
                id="btnradio2"
                autocomplete="off" />
              <label class="btn btn-outline-primary" for="btnradio2">{{ $t('offline') }}</label>
            </div>
            <div id="online-counselor" v-if="this.consultation_type === 'online'">
              <div
                v-for="(counselor, index) in counselors"
                v-bind:key="counselor"
                :class="index === 0 ? 'col' : 'col'"
                class="text-center click-effect mb-3"
                data-bs-dismiss="modal"
                @click="select_counselor(index)">
                <div class="card shadow">
                  <div class="card-body">
                    <div class="d-flex align-items-center gap-4">
                      <img
                        :src="`/img/counselor/team-member-${counselor.id}.jpg`"
                        class="rounded-circle d-block img-thumbnail shadow border"
                        width="120"
                        :alt="`${counselor.name}`" />
                      <div class="text-start">
                        <p class="fw-bold p-0 m-0">{{ counselor.name }}</p>
                        <p class="p-0 m-0">Rp. {{ Intl.NumberFormat('id').format(counselor.price) }}</p>
                        <p>{{ counselor.mileage }}+ {{ $t('satisfiedClient') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="offline-counselor" v-else-if="this.consultation_type === 'offline'">
              <div class="card shadow" data-bs-dismiss="modal" @click="select_counselor(2)">
                <div class="card-body">
                  <div class="d-flex align-items-center gap-4">
                    <img
                      :src="`/img/counselor/team-member-${this.counselors[2].id}.jpg`"
                      class="rounded-circle d-block img-thumbnail shadow border"
                      width="120"
                      :alt="`${this.counselors[2].name}`" />
                    <div class="text-start">
                      <p class="fw-bold p-0 m-0">{{ this.counselors[2].name }}</p>
                      <p class="p-0 m-0">Rp. {{ Intl.NumberFormat('id').format(this.counselors[2].price) }}</p>
                      <p>{{ this.counselors[2].mileage }}+ {{ $t('satisfiedClient') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '../components/Navigation'
import BottomNav from '../components/BottomNav'
import Swal from 'sweetalert2'

export default {
  name: 'PackageDetail',
  components: { BottomNav, Navigation },
  data() {
    return {
      package: [],
      counselors: [
        // {id: 1, name: 'Dedi Priadi', price: '600000'},
        // {id: 2, name: 'Annas Baihaqi', price: '250000', activeDays: [{day: 'Sabtu', hour: '13:00 - 20:00'}, {day: 'Minggu', hour: '10:00 - 20:00' }]},
        {
          id: 2,
          name: 'Annas Baihaqi',
          price: '300000',
          mileage: 20000,
          activeDays: [
            { day: "Senin - Jum'at", hour: '10:00 - 16:45' },
            { day: 'Sabtu', hour: '10:00 - 14:45' },
          ],
        },
        {
          id: 3,
          name: 'Sheila Rumai Halida',
          price: '250000',
          mileage: 9000,
          activeDays: [
            { day: "Senin - Jum'at", hour: '10:00 - 16:45' },
            { day: 'Sabtu', hour: '10:00 - 14:45' },
          ],
        },
        {
          id: 4,
          name: 'Lucky Pramarta',
          price: '250000',
          mileage: 2500,
          activeDays: [
            { day: "Senin - Jum'at", hour: '10:00 - 16:45' },
            { day: 'Sabtu', hour: '10:00 - 14:45' },
          ],
        },
      ],
      selected_counselor: {
        id: '',
        name: '',
        price: '',
      },
      totalPrice: '',
      consultation_type: '',
    }
  },
  mounted() {
    document.body.style.backgroundColor = '#EEEFFF'
    this.package = this.$store.getters.getPackage
    this.totalPrice = this.package.price
  },
  unmounted() {
    document.body.style.backgroundColor = '#FFFFFF'
  },
  methods: {
    toggleCounselor() {
      document.getElementById('btn-open-modal').click()
      let checkbox = document.getElementById('check_counselor')
      checkbox.checked = false
    },
    select_counselor(id) {
      let checkbox = document.getElementById('check_counselor')
      checkbox.checked = true
      this.selected_counselor.id = this.counselors[id].id
      this.selected_counselor.name = this.counselors[id].name
      this.selected_counselor.price = this.counselors[id].price

      if (this.package.is_consultation === '0')
        this.totalPrice = parseInt(this.package.price) + parseInt(this.selected_counselor.price)
      else this.totalPrice = parseInt(this.package.price)
    },
    cancel_counselor() {
      let checkbox = document.getElementById('check_counselor')
      checkbox.checked = false
      this.selected_counselor = {
        id: '',
        name: '',
        price: '',
      }
      this.totalPrice = parseInt(this.package.price)
    },
    triggerPesan() {
      this.$store.dispatch('setPackageData', {
        counselor_id: this.selected_counselor.id,
        counselor_name: this.selected_counselor.name,
        counselor_price: this.selected_counselor.price,
        total_price: this.totalPrice,
        consultation_type: this.consultation_type,
      })

      if (this.package.is_consultation === '1')
        if (!this.selected_counselor.name) Swal.fire('Error', 'Mohon pilih konselor sebelum melanjutkan', 'warning')
        else this.$router.push('/add_transaction')
      else this.$router.push('/add_transaction')
    },
  },
}
</script>

<style scoped>
body {
  background-color: #2bbdc8;
}

.bg-finger {
  background: #08a0f1 url('/img/fpimageup.png');
  background-size: cover;
}

.package-card {
  border-radius: 20px;
  /*background-image: url('/img/fingershadow1.png');*/
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
}

.feature {
  column-width: auto;
  column-count: 2;
}

.feature li {
  list-style-type: '✔';
  padding-inline-start: 1ch;
}

.padding-tab-content {
  padding-top: 1em;
}

@media only screen and (min-width: 320px) {
  .padding-card-promo {
    padding-top: 1.5em;
  }

  .package-name {
    font-size: 10pt;
  }

  .package-target {
    font-size: 8pt;
  }

  .package-consultation {
    font-size: 7pt;
  }

  .package-price {
    font-size: 7pt;
  }

  .package-btn {
    font-size: 9pt;
  }

  .consult-check-label {
    font-size: 8pt;
  }
}

@media only screen and (min-width: 375px) {
  .padding-card-promo {
    padding-top: 1.5em;
  }

  .package-name {
    font-size: 12pt;
  }

  .package-target {
    font-size: 10pt;
  }

  .package-consultation {
    font-size: 9pt;
  }

  .package-price {
    font-size: 10pt;
  }

  .package-btn {
    font-size: 10pt;
  }

  .consult-check-label {
    font-size: 8pt;
  }
}

@media only screen and (min-width: 425px) {
  .padding-card-promo {
    padding-top: 2em;
  }

  .package-name {
    font-size: 13pt;
  }

  .package-target {
    font-size: 10pt;
  }

  .package-consultation {
    font-size: 10pt;
  }

  .package-price {
    font-size: 10pt;
  }

  .package-btn {
    font-size: 10pt;
  }

  .consult-check-label {
    font-size: 9pt;
  }
}

@media only screen and (min-width: 768px) {
  .padding-card-promo {
    padding-top: 3em;
  }

  .package-name {
    font-size: 18pt;
  }

  .package-target {
    font-size: 12pt;
  }

  .package-consultation {
    font-size: 12pt;
  }

  .package-price {
    font-size: 12pt;
  }

  .package-btn {
    font-size: 14pt;
  }

  .consult-check-label {
    font-size: 12pt;
  }
}
</style>
